import * as Yup from 'yup';
import { createImageSchema, htmlStringHasText } from '../../../utils/sharedSchema.utils';
import { ImageVariant } from 'FeatureModules/Media/types/media.types';
import { ERequestType } from 'FeatureModules/Partner/types/partner.types';

export interface IPartnerFormValues {
  id?: string;
  title: string;
  email?: string;
  image?: ImageVariant;
  externalId?: string;
  countriesOfBusiness?: string[];
}

export const partnerSchema = Yup.object().shape({
  id: Yup.string().nullable(),
  image: createImageSchema({
    message: 'Please add an image of your partner',
    required: false,
  }),
  title: Yup.string().default('').required('This field is required'),
  externalId: Yup.string().nullable(),
}) as Yup.ObjectSchema<IPartnerFormValues>;

export const partnerInviteSchema = Yup.object().shape({
  id: Yup.string().nullable(),
  image: createImageSchema({
    message: 'Please add an image of your partner',
    required: false,
  }),
  email: Yup.string()
    .default('')
    .email('Please enter a valid email')
    .required('This field is required'),
  title: Yup.string().default('').required('This field is required'),
  externalId: Yup.string().nullable(),
  countriesOfBusiness: Yup.array().of(Yup.string()),
}) as Yup.ObjectSchema<IPartnerFormValues>;

export const PartnerReInviteSchema = Yup.object().shape({
  email: Yup.string()
    .default('')
    .email('Please enter a valid email')
    .required('This field is required'),
});

export const PartnerRequestSchema = Yup.object().shape({
  requestTitle: Yup.string().required('Title is required'),
  requestMessage: Yup.string().default('').label('Message'),
  requestType: Yup.string()
    .default(ERequestType.DOCUMENT)
    .oneOf([ERequestType.DOCUMENT, ERequestType.CHAIN, ERequestType.QUESTIONNAIRE])
    .required(),
  componentId: Yup.string()
    .default('')
    .nullable()
    .when('requestType', {
      is: ERequestType.CHAIN,
      then: Yup.string().required('Please add a component'),
    }),
  questionnaireId: Yup.string()
    .default('')
    .nullable()
    .when('requestType', {
      is: ERequestType.QUESTIONNAIRE,
      then: Yup.string().required('Please add a questionnaire'),
    }),
});

export const PartnerDenyRequestSchema = Yup.object().shape({
  requestMessage: Yup.string().default('').label('Message').test(htmlStringHasText),
});
